const PRIVATE_ROUTE_PREFIXES = ['/admin', '/login', '/api/admin']

export function isPrivateRoute(pathname: string): boolean {
  return PRIVATE_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  )
}
